// Create an audio context and buffer for the buzzer sound
let audioContext = null;
let audioBuffer = null;
let gainNode = null;

// Initialize the audio context and load the buzzer sound
export const initBuzzer = async () => {
  try {
    audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const response = await fetch('/buzzer.wav');
    const arrayBuffer = await response.arrayBuffer();
    audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
    
    // Create gain node for volume control
    gainNode = audioContext.createGain();
    gainNode.connect(audioContext.destination);
  } catch (error) {
    console.error('Error initializing buzzer:', error);
  }
};

// Play the buzzer sound
export const playBuzzer = () => {
  // Check if buzzer is enabled in localStorage
  const isBuzzerEnabled = localStorage.getItem('isBuzzerEnabled') !== 'false';
  if (!isBuzzerEnabled) return;

  if (!audioContext || !audioBuffer || !gainNode) {
    console.warn('Buzzer not initialized');
    return;
  }

  try {
    // Get volume from localStorage
    const buzzerVolume = parseFloat(localStorage.getItem('buzzerVolume')) || 0.5;
    gainNode.gain.value = buzzerVolume;

    const source = audioContext.createBufferSource();
    source.buffer = audioBuffer;
    source.connect(gainNode);
    source.start(0);
  } catch (error) {
    console.error('Error playing buzzer:', error);
  }
};
